import '../css/layout.css';
const GLOBALS = require("./globals.js"); //This needs to be imported in every file where it is used

$config.defaultPage = 'dashboard';
$config.ui = {};
$config.ui.name = 'web';
$config.ui.version = 1.9;
$config.testMode = false;

// redirect to mobile version when necessary
if ($config.mobile) {
    if ($config.isTabletDevice()) {
        $config.mobile = false;
    } else {
        document.location = "mobile.html";
    }
}


// WEBPACK FOOTER //
// ./src/js/index.js